export const imageData1 = [
  {
    srcSet: "img/drone_1.jpg 300w, img/drone_2.jpg 1000w",
    src: "img/drone_2.jpg",
    alt: "Photo 1",
    className:
      "top-[-7vw] left-[-10%] xs:top-[-5vw] md:top-[-3vw] lg:top-[3vw] xl:top-[2vw] 2xl:top-[-2rem]",
    scale: 1.1,
  },
  {
    srcSet: "img/drone_2.jpg 300w, img/drone3.jpg 1000w",
    src: "img/drone3.jpg",
    alt: "Photo 2",
    className: "top-0 right-[-10%] lg:top-[7vw] xl:top-[5vw] 2xl:top-[1rem]",
    scale: 1.15,
  },
  {
    srcSet: "img/drone3.jpg 300w, img/drone_1.jpg 1000w",
    src: "img/drone_1.jpg",
    alt: "Photo 3",
    className:
      "top-[15vw] left-[10%] xxs:top-[10vw] xs:top-[10vw] md:top-[7vw] lg:top-[11vw] xl:top-[9vw] 2xl:top-[8rem]",
    scale: 1.1,
  },
];

export const imageData2 = [
  {
    srcSet: "img/sensor_1.jpg 300w, img/sensor_2.jpg 1000w",
    src: "img/senzor_2.jpg",
    alt: "New Photo 1",
    className:
      "top-[-7vw] left-[-10%] xs:top-[-5vw] md:top-[-3vw] lg:top-[3vw] xl:top-[2vw] 2xl:top-[-2rem]",
    scale: 1.1,
  },
  {
    srcSet: "img/sensor_2.jpg 300w, img/sensor_3.jpg 1000w",
    src: "img/sensor_3.jpg",
    alt: "New Photo 2",
    className: "top-0 right-[-10%] lg:top-[7vw] xl:top-[5vw] 2xl:top-[1rem]",
    scale: 1.2,
  },
  {
    srcSet: "img/sensor_3.jpg 300w, img/sensor_1.jpg 1000w",
    src: "img/sensor_1.jpg",
    alt: "New Photo 3",
    className: "top-[15vw] left-[10%] xxs:top-[10vw] xs:top-[10vw] md:top-[7vw] lg:top-[11vw] xl:top-[9vw] 2xl:top-[6rem]",
    scale: 1.05,
  },
];

export const imageData3 = [
  {
    srcSet: "img/news8.1.png 300w, img/news8.2.png 1000w",
    src: "img/news8.2.png",
    alt: "New Photo 1",
    className:
      "top-[-7vw] left-[-10%] xs:top-[-5vw] md:top-[-3vw] lg:top-[3vw] xl:top-[2vw] 2xl:top-[-2rem]",
    scale: 1.1,
  },
  {
    srcSet: "img/news8.2.png 300w, img/news8.3.png 1000w",
    src: "img/news8.3.png",
    alt: "New Photo 2",
    className: "top-0 right-[-10%] lg:top-[7vw] xl:top-[5vw] 2xl:top-[1rem]",
    scale: 1.2,
  },
  {
    srcSet: "img/news8.3.png 300w, img/news8.1.png 1000w",
    src: "img/news8.1.png",
    alt: "New Photo 3",
    className: "top-[15vw] left-[10%] xxs:top-[10vw] xs:top-[10vw] md:top-[7vw] lg:top-[11vw] xl:top-[9vw] 2xl:top-[7rem]",
    scale: 1.05,
  },
];

export const imageData4 = [
  {
    srcSet: "img/vehicle.jpg 300w, img/vehicle1.jpg 1000w",
    src: "img/vehilce1.jpg",
    alt: "New Photo 1",
    className:
      "top-[-7vw] left-[-10%] xs:top-[-5vw] md:top-[-3vw] lg:top-[3vw] xl:top-[2vw] 2xl:top-[-2rem]",
    scale: 1.1,
  },
  {
    srcSet: "img/vehicle1.jpg 300w, img/vehicle2.jpg 1000w",
    src: "img/vehicle2.jpg",
    alt: "New Photo 2",
    className: "top-0 right-[-10%] lg:top-[7vw] xl:top-[5vw] 2xl:top-[1rem]",
    scale: 1.2,
  },
  {
    srcSet: "img/vehicle2.jpg 300w, img/vehicle.jpg 1000w",
    src: "img/vehicle.jpg",
    alt: "New Photo 3",
    className:
      "top-[15vw] left-[10%] xxs:top-[10vw] xs:top-[10vw] md:top-[7vw] lg:top-[11vw] xl:top-[9vw] 2xl:top-[8rem]",
    scale: 1.05,
  },
];

export const imageData5 = [
  {
    srcSet: "img/application.png 300w, img/application1.png 1000w",
    src: "img/application1.png",
    alt: "New Photo 1",
    className:
      "top-[-7vw] left-[-10%] xs:top-[-5vw] md:top-[-3vw] lg:top-[3vw] xl:top-[2vw] 2xl:top-[-2rem]",
    scale: 1.1,
  },
  {
    srcSet: "img/application1.png 300w, img/application2.png 1000w",
    src: "img/application2.png",
    alt: "New Photo 2",
    className: "top-0 right-[-10%] lg:top-[7vw] xl:top-[5vw] 2xl:top-[1rem]",
    scale: 1.2,
  },
  {
    srcSet: "img/application2.png 300w, img/application.png 1000w",
    src: "img/application.png",
    alt: "New Photo 3",
    className:
      "top-[15vw] left-[10%] xxs:top-[10vw] xs:top-[10vw] md:top-[7vw] lg:top-[11vw] xl:top-[9vw] 2xl:top-[8rem]",
    scale: 1.05,
  },
];
